import {
	Listbox,
	ListboxOption,
	ListboxOptions,
	ListboxButton,
} from '@headlessui/react'
import { CaretDown } from '../icons'
import { TypographyCaps, TypographyLabel } from '../typography'
import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'

export type selectOption = {
	name: string
	icon: any
	slug: string
	symbol?: string
	version: string
}

export default function Dropdown({
	options = [],
	title,
	placeholder = 'Select an option',
	selected,
	onSelectionChange,
	containerClasses = '',
	additionalClasses = '',
	disabled = false,
}: {
	options: selectOption[]
	title?: string
	placeholder?: string
	selected: selectOption | null
	onSelectionChange: (selected: selectOption) => void
	containerClasses?: string
	additionalClasses?: string
	disabled?: boolean
}) {
	// @ts-ignore
	const handleChange = (v: string) => {
		if (v) {
			const newSelectionValue = options.find(option => option.name === v)
			if (newSelectionValue) {
				onSelectionChange(newSelectionValue)
			}
		}
	}
	return (
		<>
			{title && (
				<TypographyCaps
					size="small"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					{title}
				</TypographyCaps>
			)}
			<Listbox
				disabled={disabled}
				value={selected}
				// @ts-ignore
				onChange={handleChange}
				// by={(a, z) => a.name === z.name}
			>
				{({ open }) => (
					<div className={clsx('relative', containerClasses)}>
						<ListboxButton
							className={twMerge(
								'w-full px-4 py-3 font-abc text-paragraphMedium outline-0',
								'border border-textInactiveLight hover:border-textPrimaryLight focus:border-textPrimaryLight',
								'dark:border-textInactiveDark dark:hover:border-textPrimaryDark dark:focus:border-textPrimaryDark',
								'text-textPrimaryLight dark:text-textPrimaryDark',
								'text-left relative cursor-pointer rounded-md transition-all',
								'bg-white dark:bg-dark',
								additionalClasses,
							)}
						>
							<span className="flex items-center">
								<span className="block">
									<TypographyLabel
										size="medium"
										isBold={false}
										additionalClasses={
											selected ? '' : 'text-grey400 dark:text-grey600'
										}
									>
										{selected ? selected.name : placeholder}
									</TypographyLabel>
								</span>
								<span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-3.5">
									<CaretDown
										className={clsx(
											'h-5 w-5 transform transition-all ease-linear',
											open ? 'rotate-180' : 'rotate-0',
										)}
										aria-hidden="true"
									/>
								</span>
							</span>
						</ListboxButton>
						{/* )} */}
						<ListboxOptions
							modal={false}
							// anchor="bottom"
							// transition
							className={clsx(
								'absolute z-10 w-full max-w-[603px] py-4',
								' ring-none shadow-md',
								// 'origin-top transition duration-200 ease-in-out',
								// open ? 'scale-100 opacity-1' : 'scale-95 opacity-0',
								'mt-1 overflow-auto rounded-2xl text-base ring-0 focus:outline-none',
								'text-textSecondaryDark dark:text-textSecondaryLight',
								'bg-uiTertiaryDark dark:bg-uiTertiaryLight'
							)}
						>
							{options.map(option => (
								<ListboxOption
									key={option.name}
									value={option.name}
									className={clsx(
										'flex h-10 w-full cursor-pointer px-4',
										// 'group relative cursor-pointer select-none',
										'data-[focus]:bg-uiPrimaryDark data-[focus]:dark:bg-white',
										'data[focus]:text-textPrimaryDark data-[focus]:dark:text-textPrimaryLight',
										'hover:bg-uiPrimaryDark hover:dark:bg-white hover:text-textPrimaryDark hover:dark:text-textPrimaryLight',
									)}
								>
									<div className="flex w-full items-center text-center">
										{option.icon && (
											<div className="flex w-8 items-center justify-center">
												{option.icon}
											</div>
										)}
										<span className={clsx('block w-full text-left')}>
											<TypographyLabel size="medium" isBold={true}>
												{option.name}
											</TypographyLabel>
										</span>
									</div>
								</ListboxOption>
							))}
						</ListboxOptions>
					</div>
				)}
			</Listbox>
		</>
	)
}
